import {
  SourcingOpeningUpdateParameters,
  SourcingService,
} from 'api-clients/monolith';

export interface UpdateOpeningParams {
  openingExternalId: string;
  requestBody: SourcingOpeningUpdateParameters;
}

export function updateOpening(params: UpdateOpeningParams) {
  const { openingExternalId, requestBody } = params;

  return SourcingService.putInternalApiSourcingOpenings(
    openingExternalId,
    requestBody,
  );
}
